{
  "Common": {
    "close": "閉じる",
    "closeAlert": "アラートを閉じる",
    "notifications": "通知",
    "newNotification": "新規",
    "readStatus": "既読",
    "openLink": "リンクを開く",
    "theme": "テーマ",
    "lightTheme": "ライト",
    "darkTheme": "ダーク",
    "systemTheme": "システム",
    "density": "密度",
    "compact": "コンパクト",
    "normal": "通常",
    "comfortable": "ゆったり",
    "columns": "列",
    "loading": "読み込み中",
    "noData": "データがありません",
    "clearFilter": "フィルターをクリア",
    "selectAll": "すべて選択",
    "default": "デフォルト",
    "other": "その他",
    "headerAlign": "ヘッダー配置",
    "alignLeft": "左揃え",
    "alignCenter": "中央揃え",
    "alignRight": "右揃え"
  },
  "ValidationInput": {
    "required": "この項目は必須です",
    "typeMismatch": "形式が正しくありません",
    "pattern": "パターンが一致しません",
    "tooShort": "短すぎます",
    "tooLong": "長すぎます",
    "rangeUnderflow": "最小値より小さいです",
    "rangeOverflow": "最大値を超えています",
    "stepMismatch": "ステップが一致しません",
    "badInput": "入力が無効です",
    "invalid": "無効な値です"
  },
  "Loading": {
    "loadingPage": "ページを読み込み中",
    "pleaseWait": "しばらくお待ちください"
  },
  "DatePicker": {
    "placeholder": "日付を選択",
    "today": "今日",
    "clear": "クリア"
  },
  "DateTimePicker": {
    "time": "時間",
    "clear": "クリア",
    "done": "完了"
  },
  "CalendarTimeline": {
    "today": "今日",
    "prev": "前へ",
    "next": "次へ",
    "month": "月",
    "week": "週",
    "day": "日",
    "sprint": "スプリント",
    "newEvent": "新規イベント",
    "createEventTitle": "イベント作成",
    "create": "作成",
    "cancel": "キャンセル",
    "resource": "リソース",
    "start": "開始",
    "end": "終了",
    "resourcesHeader": "リソース",
    "expandGroup": "グループを展開",
    "collapseGroup": "グループを折りたたむ",
    "more": "+{n}件",
    "sprints": "{n} スプリント",
    "deleteConfirm": "削除しますか？"
  },
  "Pagination": {
    "navigationLabel": "ページナビゲーション",
    "showingResults": "{startItem}–{endItem} / 全{totalItems}件",
    "firstPage": "最初のページ",
    "previousPage": "前のページ",
    "previous": "前へ",
    "nextPage": "次のページ",
    "next": "次へ",
    "lastPage": "最後のページ",
    "pageNumber": "{page}ページ",
    "itemsPerPage": "1ページあたりの項目数",
    "search": "検索",
    "noOptions": "オプションなし"
  },
  "OCR": {
    "imageUpload": {
      "dragDropText": "ここにファイルをドラッグ＆ドロップ",
      "browseFiles": "ファイルを参照",
      "supportedFormats": "対応形式：画像"
    }
  },
  "FileUpload": {
    "dragDropText": "ここにファイルをドラッグ＆ドロップ",
    "browseFiles": "ファイルを選択",
    "uploadFiles": "ファイルをアップロード",
    "supportedFormats": "すべてのファイル形式に対応",
    "uploadedFiles": "アップロードされたファイル",
    "clearAll": "すべてクリア",
    "fileTooLarge": "サイズ制限を超えています。",
    "maxFilesReached": "最大ファイル数に達しました。",
    "uploadSuccess": "アップロードしました。",
    "uploadFailed": "アップロードに失敗しました。"
  },
  "UEditor": {
    "placeholder": "コマンドを使用するには '/' を入力、または入力を開始...",
    "loading": "エディタを読み込み中...",
    "words": "単語",
    "characters": "文字",
    "colors": {
      "default": "デフォルト",
      "muted": "ミュート",
      "primary": "プライマリ",
      "secondary": "セカンダリ",
      "success": "成功",
      "warning": "警告",
      "destructive": "破壊的",
      "info": "情報",
      "accent": "アクセント",
      "textColor": "テキスト色",
      "highlight": "ハイライト",
      "automatic": "自動",
      "moreColors": "その他の色...",
      "color": "色",
      "done": "完了"
    },
    "toolbar": {
      "bold": "太字",
      "boldShortcut": "太字 (Ctrl+B)",
      "italic": "斜体",
      "italicShortcut": "斜体 (Ctrl+I)",
      "underline": "下線",
      "underlineShortcut": "下線 (Ctrl+U)",
      "strike": "取り消し線",
      "code": "コード",
      "subscript": "下付き",
      "superscript": "上付き",
      "link": "リンク",
      "removeLink": "リンクを解除",
      "image": "画像",
      "table": "表",
      "alignment": "配置",
      "alignLeft": "左揃え",
      "alignCenter": "中央揃え",
      "alignRight": "右揃え",
      "justify": "両端揃え",
      "bulletList": "箇条書き",
      "orderedList": "番号付きリスト",
      "taskList": "タスクリスト",
      "quote": "引用",
      "codeBlock": "コードブロック",
      "undo": "元に戻す",
      "redo": "やり直し",
      "textStyle": "テキストスタイル",
      "fontFamily": "フォント",
      "fontSize": "文字サイズ",
      "lineHeight": "行間",
      "fontDefault": "標準フォント",
      "sizeDefault": "標準サイズ",
      "lineHeightDefault": "標準の行間",
      "letterSpacing": "文字間隔",
      "letterSpacingDefault": "標準の字間",
      "fontSans": "Sans",
      "fontSerif": "Serif",
      "fontMono": "Mono",
      "normal": "標準テキスト",
      "heading1": "見出し 1",
      "heading2": "見出し 2",
      "heading3": "見出し 3",
      "emoji": "絵文字を挿入",
      "imageLayoutBlock": "画像ブロック",
      "imageLayoutLeft": "画像を左、文字を右に回り込み",
      "imageLayoutRight": "画像を右、文字を左に回り込み",
      "imageWidthSm": "画像（小）",
      "imageWidthMd": "画像（中）",
      "imageWidthLg": "画像（大）",
      "imageResetSize": "画像サイズをリセット",
      "imageDelete": "画像を削除"
    },
    "slashCommand": {
      "basicBlocks": "基本ブロック",
      "text": "テキスト",
      "textDesc": "プレーンテキストブロック",
      "heading1": "見出し 1",
      "heading1Desc": "大見出し",
      "heading2": "見出し 2",
      "heading2Desc": "中見出し",
      "heading3": "見出し 3",
      "heading3Desc": "小見出し",
      "bulletList": "箇条書き",
      "bulletListDesc": "シンプルな箇条書きリスト",
      "orderedList": "番号付きリスト",
      "orderedListDesc": "番号順のリスト",
      "todoList": "タスクリスト",
      "todoListDesc": "チェックボックス付きリスト",
      "quote": "引用",
      "quoteDesc": "引用ブロック",
      "codeBlock": "コードブロック",
      "codeBlockDesc": "シンタックスハイライト付きコード",
      "divider": "区切り線",
      "dividerDesc": "視覚的な区切り線",
      "table": "表",
      "tableDesc": "表を追加",
      "noResults": "一致するブロックが見つかりません",
      "callout": "コールアウト",
      "calloutDesc": "重要な情報をコールアウトブロックで強調します",
      "bookmark": "ブックマークカード",
      "bookmarkDesc": "リンクをブックマークカードとして埋め込みます",
      "fileCard": "ファイル添付",
      "fileCardDesc": "ファイルカードの添付ファイルをアップロードします",
      "formCheckbox": "フォームチェックボックス",
      "formCheckboxDesc": "インタラクティブなチェックボックスを挿入します",
      "formRadio": "フォームラジオボタン",
      "formRadioDesc": "インタラクティブなラジオボタンを挿入します"
    },
    "floatingMenu": {
      "addBlock": "ブロックを追加"
    },
    "linkInput": {
      "placeholder": "リンクを貼り付けまたは入力..."
    },
    "imageInput": {
      "urlTab": "URL",
      "uploadTab": "アップロード",
      "urlLabel": "画像 URL",
      "urlPlaceholder": "https://example.com/image.jpg",
      "uploadLabel": "画像を選択",
      "uploadPlaceholder": "クリックして画像をアップロード",
      "uploading": "アップロード中...",
      "uploadError": "アップロード失敗。もう一度お試しください。",
      "altLabel": "代替テキスト (任意)",
      "altPlaceholder": "画像の説明...",
      "addBtn": "画像を追加",
      "cancelBtn": "キャンセル",
      "addFromUrl": "URLから追加"
    },
    "emojiPicker": {
      "searchPlaceholder": "絵文字を検索",
      "noResults": "絵文字が見つかりません",
      "tryDifferentSearch": "別のキーワードでお試しください"
    },
    "stickerPicker": {
      "searchPlaceholder": "ステッカーを検索",
      "noResults": "ステッカーが見つかりません",
      "tryDifferentSearch": "別のキーワードでお試しください"
    },
    "emojiSuggestion": {
      "title": "絵文字",
      "noResults": "絵文字が見つかりません",
      "showingCount": "{total} 件中 {shown} 件の絵文字を表示中"
    },
    "formulaSuggestion": {
      "title": "関数",
      "noResults": "関数が見つかりません",
      "sum": "範囲内の値を合計",
      "avg": "範囲内の値の平均",
      "min": "範囲内の最小値",
      "max": "範囲内の最大値",
      "count": "範囲内の数値セルをカウント"
    },
    "tableMenu": {
      "insert3x3": "3x3 表を挿入",
      "insertTable": "表を挿入",
      "gridPreview": "{rows}×{cols} の表を挿入",
      "addColumnBefore": "前に列を追加",
      "addColumnAfter": "後に列を追加",
      "addRowBefore": "前に行を追加",
      "addRowAfter": "後に行を追加",
      "duplicateColumn": "列を複製",
      "duplicateRow": "行を複製",
      "clearColumnContents": "列の内容をクリア",
      "clearRowContents": "行の内容をクリア",
      "deleteColumn": "列を削除",
      "deleteRow": "行を削除",
      "deleteTable": "表を削除",
      "toggleHeaderRow": "ヘッダー行を切り替え",
      "toggleHeaderColumn": "ヘッダー列を切り替え",
      "mergeCells": "セルを結合",
      "splitCell": "セルを分割",
      "openControls": "表コントロールを開く",
      "quickAddColumnAfter": "右側に列をすばやく追加",
      "quickAddRowAfter": "下に行をすばやく追加",
      "expandTable": "表を拡張",
      "dragRow": "行をドラッグ",
      "dragColumn": "列をドラッグ",
      "alignLeft": "表を左寄せ",
      "alignCenter": "表を中央揃え",
      "alignRight": "表を右寄せ",
      "cellBackground": "セル背景色",
      "cellBorder": "セルの枠線",
      "borderStyle": "枠線スタイル",
      "borderWidth": "枠線の太さ",
      "borderColor": "枠線の色",
      "clearBorder": "枠線をクリア",
      "formula": "数式",
      "numberFormat": "表示形式",
      "formatText": "テキスト",
      "formatDate": "日付",
      "apply": "適用",
      "clear": "クリア",
      "recalculate": "再計算",
      "done": "完了",
      "alignVertical": "垂直揃え",
      "alignVerticalTop": "上揃え",
      "alignVerticalMiddle": "上下中央揃え",
      "alignVerticalBottom": "下揃え"
    },
    "callout": {
      "selectEmoji": "絵文字を選択",
      "backgroundColor": "背景色"
    },
    "radio": {
      "groupName": "グループ名",
      "editGroup": "グループ名編集"
    },
    "bookmark": {
      "clickToOpenNewTab": "クリックしてこのリンクを新しいタブで開く。",
      "clickToOpenLink": "クリックしてリンクを開く。",
      "noDescription": "説明はありません。",
      "failedToLoad": "プレビューの読み込みに失敗しました。クリックしてリンクを開く。",
      "previewFailed": "プレビューを読み込めませんでした",
      "retryPreview": "再試行"
    },
    "fileCard": {
      "unnamed": "名前なしファイル",
      "uploading": "(アップロード中...)",
      "uploadFailed": "アップロード失敗",
      "retryUpload": "再アップロード"
    },
    "menubar": {
      "file": "ファイル",
      "edit": "編集",
      "view": "表示",
      "insert": "挿入",
      "format": "書式",
      "tools": "ツール",
      "table": "表",
      "save": "保存",
      "exportHtml": "HTMLエクスポート",
      "undo": "元に戻す",
      "undoShortcut": "Ctrl+Z",
      "redo": "やり直し",
      "redoShortcut": "Ctrl+Y",
      "cut": "切り取り",
      "cutShortcut": "Ctrl+X",
      "copy": "コピー",
      "copyShortcut": "Ctrl+C",
      "paste": "貼り付け",
      "pasteShortcut": "Ctrl+V",
      "pasteAsText": "テキストとして貼り付け",
      "selectAll": "すべて選択",
      "selectAllShortcut": "Ctrl+A",
      "sourceCode": "ソースコード",
      "preview": "プレビュー",
      "fullscreen": "フルスクリーン",
      "fullscreenShortcut": "Ctrl+Shift+F",
      "image": "画像",
      "link": "リンク",
      "linkShortcut": "Ctrl+K",
      "insertTable": "表",
      "horizontalRule": "水平線",
      "bold": "太字",
      "boldShortcut": "Ctrl+B",
      "italic": "斜体",
      "italicShortcut": "Ctrl+I",
      "underline": "下線",
      "underlineShortcut": "Ctrl+U",
      "strike": "取り消し線",
      "superscript": "上付き文字",
      "subscript": "下付き文字",
      "code": "コード",
      "wrap": "ブロック",
      "align": "配置",
      "clearFormatting": "書式をクリア",
      "paragraph": "段落",
      "heading1": "見出し 1",
      "heading2": "見出し 2",
      "heading3": "見出し 3",
      "blockquote": "引用",
      "codeBlock": "コードブロック",
      "taskList": "タスクリスト",
      "alignLeft": "左揃え",
      "alignCenter": "中央揃え",
      "alignRight": "右揃え",
      "alignJustify": "両端揃え",
      "tableProperties": "表のプロパティ",
      "deleteTable": "表を削除",
      "row": "行",
      "column": "列",
      "cell": "セル",
      "addRowBefore": "上に行を挿入",
      "addRowAfter": "下に行を挿入",
      "deleteRow": "行を削除",
      "addColumnBefore": "左に列を挿入",
      "addColumnAfter": "右に列を挿入",
      "deleteColumn": "列を削除",
      "mergeCells": "セルを結合",
      "splitCell": "セルを分割",
      "imageUpload": "画像をアップロード",
      "formFields": "フォームフィールド",
      "formCheckbox": "フォームチェックボックス",
      "formRadio": "フォームラジオボタン",
      "applySource": "適用",
      "closeDialog": "閉じる",
      "copyHtml": "HTMLをコピー",
      "exportDefault": "HTMLエクスポート",
      "previewEmpty": "プレビューするコンテンツがありません。",
      "sourceCodeHint": "HTMLを直接編集し、適用をクリックしてエディターを更新します。"
    }
  }
}
